import { render, staticRenderFns } from "./board_detail_status.vue?vue&type=template&id=fc7c01a6&scoped=true"
import script from "./board_detail_status.vue?vue&type=script&lang=js"
export * from "./board_detail_status.vue?vue&type=script&lang=js"
import style0 from "./board_detail_status.vue?vue&type=style&index=0&id=fc7c01a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7c01a6",
  null
  
)

export default component.exports